import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNotification } from '../../Context/NotificationContext';
import './NotificationModal.css';

const NotificationModal = () => {
    const { notification, hideNotification } = useNotification();
    const { show, title, message, onConfirm, confirmButtonText } = notification;

    const handleClose = () => {
        hideNotification();
    };

    const handleConfirm = () => {
        hideNotification();
        if (onConfirm) {
            onConfirm();
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            animation={false}
            size="md"
            centered
            backdrop="static"
            keyboard={true}
            className="custom-notification-modal"
        >
            <Modal.Header closeButton className="lang-modal-header">
                <Modal.Title>{title || 'Notification'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="lang-modal-body">
                <div className="notification-message">
                    {message}
                </div>
                <div className="all-btns-wrap mt-4">
                    <Button
                        className="all-btns"
                        variant="warning"
                        onClick={handleConfirm}
                    >
                        {confirmButtonText || 'OK'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default NotificationModal;
